import React from 'react';
import { ICustomIconProps } from './types';

const IconBank: React.FC<ICustomIconProps> = ({ size = 20, color = '#E72547' }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18.3337 15.8333V18.3333H1.66699V15.8333C1.66699 15.375 2.04199 15 2.50033 15H17.5003C17.9587 15 18.3337 15.375 18.3337 15.8333Z'
      fill={color}
      stroke={color}
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M5.83366 9.16699H4.16699V15.0003H5.83366V9.16699Z' fill={color} />
    <path d='M9.16667 9.16699H7.5V15.0003H9.16667V9.16699Z' fill={color} />
    <path d='M12.4997 9.16699H10.833V15.0003H12.4997V9.16699Z' fill={color} />
    <path d='M15.8337 9.16699H14.167V15.0003H15.8337V9.16699Z' fill={color} />
    <path
      d='M19.1663 18.958H0.833008C0.491341 18.958 0.208008 18.6747 0.208008 18.333C0.208008 17.9913 0.491341 17.708 0.833008 17.708H19.1663C19.508 17.708 19.7913 17.9913 19.7913 18.333C19.7913 18.6747 19.508 18.958 19.1663 18.958Z'
      fill={color}
    />
    <path
      d='M17.8087 4.79121L10.3087 1.79121C10.142 1.72454 9.85866 1.72454 9.69199 1.79121L2.19199 4.79121C1.90033 4.90788 1.66699 5.24954 1.66699 5.56621V8.33288C1.66699 8.79121 2.04199 9.16621 2.50033 9.16621H17.5003C17.9587 9.16621 18.3337 8.79121 18.3337 8.33288V5.56621C18.3337 5.24954 18.1003 4.90788 17.8087 4.79121ZM10.0003 7.08288C9.30866 7.08288 8.75033 6.52454 8.75033 5.83288C8.75033 5.14121 9.30866 4.58288 10.0003 4.58288C10.692 4.58288 11.2503 5.14121 11.2503 5.83288C11.2503 6.52454 10.692 7.08288 10.0003 7.08288Z'
      fill={color}
    />
  </svg>
);

export default IconBank;
